import { useTranslation } from "react-i18next";

import { Link } from "../lib/router";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";

export function AdminLink() {
  const role = useAppStore((state) => state.auth?.role);
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);
  const { t } = useTranslation();

  if (role !== "admin") return null;

  return (
    <Link
      to="/admin"
      data-testid="admin-link"
      aria-label={t("admin.title")}
      className={`flex h-8 items-center rounded-lg border px-3 text-sm font-medium ${theme.bgSecondary} ${theme.border} ${theme.text} hover:opacity-80`}
    >
      {t("admin.title")}
    </Link>
  );
}
